"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4077],{

/***/ 82110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createStyled; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
var emotion_memoize_esm = __webpack_require__(45042);
;// CONCATENATED MODULE: ./node_modules/@emotion/styled/node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js


// eslint-disable-next-line no-undef
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);



// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js
var emotion_element_c39617d8_browser_esm = __webpack_require__(75260);
// EXTERNAL MODULE: ./node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var emotion_utils_browser_esm = __webpack_require__(70444);
// EXTERNAL MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.esm.js + 2 modules
var emotion_serialize_esm = __webpack_require__(85662);
// EXTERNAL MODULE: ./node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js
var emotion_use_insertion_effect_with_fallbacks_browser_esm = __webpack_require__(27278);
;// CONCATENATED MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js








var testOmitPropsOnStringTag = isPropValid;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  (0,emotion_utils_browser_esm/* registerStyles */.hC)(cache, serialized, isStringTag);
  (0,emotion_use_insertion_effect_with_fallbacks_browser_esm/* useInsertionEffectAlwaysWithSyncFallback */.L)(function () {
    return (0,emotion_utils_browser_esm/* insertStyles */.My)(cache, serialized, isStringTag);
  });

  return null;
};

var createStyled = function createStyled(tag, options) {
  if (false) {}

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (false) {}

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (false) {}

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = (0,emotion_element_c39617d8_browser_esm.w)(function (props, cache, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = react.useContext(emotion_element_c39617d8_browser_esm.T);
      }

      if (typeof props.className === 'string') {
        className = (0,emotion_utils_browser_esm/* getRegisteredStyles */.fp)(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = (0,emotion_serialize_esm/* serializeStyles */.O)(styles.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if ( // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;
      newProps.ref = ref;
      return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof FinalTag === 'string'
      }), /*#__PURE__*/react.createElement(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && "production" !== 'production') {} // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, (0,esm_extends/* default */.Z)({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };

    return Styled;
  };
};




/***/ }),

/***/ 82772:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


/* eslint-disable es/no-array-prototype-indexof -- required for testing */
var $ = __webpack_require__(82109);
var $indexOf = (__webpack_require__(41318).indexOf);
var arrayMethodIsStrict = __webpack_require__(9341);

var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 68759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$B": function() { return /* binding */ MARKETING_SMS_CONSENT; },
/* harmony export */   "N4": function() { return /* binding */ AccountFormHeader; },
/* harmony export */   "OR": function() { return /* binding */ AccountFormWrapper; },
/* harmony export */   "em": function() { return /* binding */ Disclaimer; },
/* harmony export */   "l0": function() { return /* binding */ Form; },
/* harmony export */   "lX": function() { return /* binding */ EmailDisclaimerText; },
/* harmony export */   "n5": function() { return /* binding */ FormWrapper; }
/* harmony export */ });
/* unused harmony exports CONSENT_VERSIONS, PHONE_DEFAULT_DISCLAIMER */
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96649);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82772);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96078);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(2490);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(59849);
/* harmony import */ var core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(34514);
/* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(82110);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(22470);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(46523);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
























var _excluded = [
    "children"
], _excluded2 = [
    "children",
    "desktopNoWrap",
    "shouldRenderDisclaimerAboveCTA"
];
function cov_1nsiyxuuhi() {
    var path = "/home/runner/_work/code/code/js/packages/cinderblocks/src/platform/auth/shared.tsx";
    var hash = "baa12fae82ed75710c6cdefae3c81ba5092fce3b";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/home/runner/_work/code/code/js/packages/cinderblocks/src/platform/auth/shared.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 37,
                    column: 63
                },
                end: {
                    line: 80,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 42,
                    column: 6
                },
                end: {
                    line: 42,
                    column: 107
                }
            },
            "2": {
                start: {
                    line: 44,
                    column: 6
                },
                end: {
                    line: 44,
                    column: 299
                }
            },
            "3": {
                start: {
                    line: 53,
                    column: 6
                },
                end: {
                    line: 77,
                    column: 9
                }
            },
            "4": {
                start: {
                    line: 84,
                    column: 40
                },
                end: {
                    line: 84,
                    column: 58
                }
            },
            "5": {
                start: {
                    line: 86,
                    column: 37
                },
                end: {
                    line: 89,
                    column: 1
                }
            },
            "6": {
                start: {
                    line: 97,
                    column: 72
                },
                end: {
                    line: 113,
                    column: 1
                }
            },
            "7": {
                start: {
                    line: 98,
                    column: 2
                },
                end: {
                    line: 112,
                    column: 4
                }
            },
            "8": {
                start: {
                    line: 115,
                    column: 82
                },
                end: {
                    line: 124,
                    column: 1
                }
            },
            "9": {
                start: {
                    line: 119,
                    column: 2
                },
                end: {
                    line: 123,
                    column: 4
                }
            },
            "10": {
                start: {
                    line: 126,
                    column: 54
                },
                end: {
                    line: 128,
                    column: 1
                }
            },
            "11": {
                start: {
                    line: 127,
                    column: 2
                },
                end: {
                    line: 127,
                    column: 41
                }
            },
            "12": {
                start: {
                    line: 130,
                    column: 47
                },
                end: {
                    line: 132,
                    column: 1
                }
            },
            "13": {
                start: {
                    line: 131,
                    column: 2
                },
                end: {
                    line: 131,
                    column: 64
                }
            },
            "14": {
                start: {
                    line: 139,
                    column: 40
                },
                end: {
                    line: 141,
                    column: 1
                }
            },
            "15": {
                start: {
                    line: 140,
                    column: 2
                },
                end: {
                    line: 140,
                    column: 48
                }
            },
            "16": {
                start: {
                    line: 144,
                    column: 20
                },
                end: {
                    line: 147,
                    column: 1
                }
            },
            "17": {
                start: {
                    line: 151,
                    column: 4
                },
                end: {
                    line: 165,
                    column: 1
                }
            },
            "18": {
                start: {
                    line: 152,
                    column: 2
                },
                end: {
                    line: 164,
                    column: 4
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 41,
                        column: 18
                    },
                    end: {
                        line: 41,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 42,
                        column: 6
                    },
                    end: {
                        line: 42,
                        column: 107
                    }
                },
                line: 42
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 43,
                        column: 10
                    },
                    end: {
                        line: 43,
                        column: 11
                    }
                },
                loc: {
                    start: {
                        line: 44,
                        column: 6
                    },
                    end: {
                        line: 44,
                        column: 299
                    }
                },
                line: 44
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 45,
                        column: 24
                    },
                    end: {
                        line: 45,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 53,
                        column: 6
                    },
                    end: {
                        line: 77,
                        column: 9
                    }
                },
                line: 53
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 97,
                        column: 72
                    },
                    end: {
                        line: 97,
                        column: 73
                    }
                },
                loc: {
                    start: {
                        line: 97,
                        column: 95
                    },
                    end: {
                        line: 113,
                        column: 1
                    }
                },
                line: 97
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 115,
                        column: 82
                    },
                    end: {
                        line: 115,
                        column: 83
                    }
                },
                loc: {
                    start: {
                        line: 118,
                        column: 6
                    },
                    end: {
                        line: 124,
                        column: 1
                    }
                },
                line: 118
            },
            "5": {
                name: "(anonymous_5)",
                decl: {
                    start: {
                        line: 126,
                        column: 54
                    },
                    end: {
                        line: 126,
                        column: 55
                    }
                },
                loc: {
                    start: {
                        line: 126,
                        column: 65
                    },
                    end: {
                        line: 128,
                        column: 1
                    }
                },
                line: 126
            },
            "6": {
                name: "(anonymous_6)",
                decl: {
                    start: {
                        line: 130,
                        column: 47
                    },
                    end: {
                        line: 130,
                        column: 48
                    }
                },
                loc: {
                    start: {
                        line: 130,
                        column: 58
                    },
                    end: {
                        line: 132,
                        column: 1
                    }
                },
                line: 130
            },
            "7": {
                name: "(anonymous_7)",
                decl: {
                    start: {
                        line: 139,
                        column: 40
                    },
                    end: {
                        line: 139,
                        column: 41
                    }
                },
                loc: {
                    start: {
                        line: 139,
                        column: 64
                    },
                    end: {
                        line: 141,
                        column: 1
                    }
                },
                line: 139
            },
            "8": {
                name: "(anonymous_8)",
                decl: {
                    start: {
                        line: 151,
                        column: 4
                    },
                    end: {
                        line: 151,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 151,
                        column: 87
                    },
                    end: {
                        line: 165,
                        column: 1
                    }
                },
                line: 151
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 49,
                        column: 6
                    },
                    end: {
                        line: 49,
                        column: 49
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 49,
                            column: 15
                        },
                        end: {
                            line: 49,
                            column: 49
                        }
                    }
                ],
                line: 49
            },
            "1": {
                loc: {
                    start: {
                        line: 50,
                        column: 6
                    },
                    end: {
                        line: 50,
                        column: 55
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 50,
                            column: 19
                        },
                        end: {
                            line: 50,
                            column: 55
                        }
                    }
                ],
                line: 50
            },
            "2": {
                loc: {
                    start: {
                        line: 51,
                        column: 6
                    },
                    end: {
                        line: 51,
                        column: 20
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 51,
                            column: 18
                        },
                        end: {
                            line: 51,
                            column: 20
                        }
                    }
                ],
                line: 51
            },
            "3": {
                loc: {
                    start: {
                        line: 151,
                        column: 17
                    },
                    end: {
                        line: 151,
                        column: 38
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 151,
                            column: 33
                        },
                        end: {
                            line: 151,
                            column: 38
                        }
                    }
                ],
                line: 151
            },
            "4": {
                loc: {
                    start: {
                        line: 159,
                        column: 23
                    },
                    end: {
                        line: 159,
                        column: 75
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 159,
                            column: 39
                        },
                        end: {
                            line: 159,
                            column: 63
                        }
                    },
                    {
                        start: {
                            line: 159,
                            column: 66
                        },
                        end: {
                            line: 159,
                            column: 75
                        }
                    }
                ],
                line: 159
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0
        },
        b: {
            "0": [
                0
            ],
            "1": [
                0
            ],
            "2": [
                0
            ],
            "3": [
                0
            ],
            "4": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "baa12fae82ed75710c6cdefae3c81ba5092fce3b"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_1nsiyxuuhi = function cov_1nsiyxuuhi() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_1nsiyxuuhi();
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Versioned marketing SMS consent language registry.
 *
 * All surfaces that display marketing SMS consent copy should import
 * MARKETING_SMS_CONSENT from here.
 */ 

// ---------------------------------------------------------------------------
// Consent language registry
// ---------------------------------------------------------------------------
// DO NOT MODIFY EXISTING ENTRIES. IF YOU NEED TO UPDATE THE CONSENT LANGUAGE, ADD A NEW ENTRY TO THE OBJECT.
// WHEN LEGAL UPDATES THE COPY:
//   1. Add a new entry to CONSENT_VERSIONS (do NOT modify existing entries)
//   2. Update CURRENT_VERSION to point to the new key
//   3. Update the test
var CONSENT_VERSIONS = (cov_1nsiyxuuhi().s[0]++, {
    marketing_sms_v1: {
        checkboxLabel: "I consent to receive marketing calls and texts from Opendoor and its affiliates to the number provided. I understand that I may opt out at any time and consent is not a condition of purchase.",
        ctaAgreement: function ctaAgreement(ctaText) {
            cov_1nsiyxuuhi().f[0]++;
            cov_1nsiyxuuhi().s[1]++;
            return "By pressing “".concat(ctaText, ",” I agree to Opendoor’s Terms of Service and Privacy Policy.");
        },
        full: function full(ctaText) {
            cov_1nsiyxuuhi().f[1]++;
            cov_1nsiyxuuhi().s[2]++;
            return "I consent to receive marketing calls and texts from Opendoor and its affiliates to the number provided. I understand that I may opt out at any time and consent is not a condition of purchase. By pressing “".concat(ctaText, ",” I agree to Opendoor’s Terms of Service and Privacy Policy.");
        },
        CtaAgreementLinked: function CtaAgreementLinked(_ref) {
            var ctaText = _ref.ctaText, tosAnalyticsName = _ref.tosAnalyticsName, privacyAnalyticsName = _ref.privacyAnalyticsName, _ref$tosUrl = _ref.tosUrl, tosUrl = _ref$tosUrl === void 0 ? (cov_1nsiyxuuhi().b[0][0]++, "https://www.opendoor.com/w/terms") : _ref$tosUrl, _ref$privacyUrl = _ref.privacyUrl, privacyUrl = _ref$privacyUrl === void 0 ? (cov_1nsiyxuuhi().b[1][0]++, "https://www.opendoor.com/w/privacy") : _ref$privacyUrl, _ref$linkProps = _ref.linkProps, linkProps = _ref$linkProps === void 0 ? (cov_1nsiyxuuhi().b[2][0]++, {}) : _ref$linkProps;
            cov_1nsiyxuuhi().f[2]++;
            cov_1nsiyxuuhi().s[3]++;
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_24__.createElement(react__WEBPACK_IMPORTED_MODULE_24__.Fragment, null, "By pressing “", ctaText, ",” I agree to Opendoor’s", " ", /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_24__.createElement(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_25__/* .Link */ .r, _extends({
                analyticsName: tosAnalyticsName,
                href: tosUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                "aria-label": "Opens a new page with Opendoor’s terms of service"
            }, linkProps), "Terms of Service"), " ", "and", " ", /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_24__.createElement(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_25__/* .Link */ .r, _extends({
                analyticsName: privacyAnalyticsName,
                href: privacyUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                "aria-label": "Opens a new page with Opendoor’s privacy policy"
            }, linkProps), "Privacy Policy"), ".");
        }
    }
});
var CURRENT_VERSION = (cov_1nsiyxuuhi().s[4]++, "marketing_sms_v1");
var MARKETING_SMS_CONSENT = (cov_1nsiyxuuhi().s[5]++, _objectSpread({
    version: CURRENT_VERSION
}, CONSENT_VERSIONS[CURRENT_VERSION]));

// ---------------------------------------------------------------------------
// Shared auth UI components
// ---------------------------------------------------------------------------
cov_1nsiyxuuhi().s[6]++;
var EmailDisclaimerText = function EmailDisclaimerText(_ref2) {
    var analyticsName = _ref2.analyticsName;
    cov_1nsiyxuuhi().f[3]++;
    cov_1nsiyxuuhi().s[7]++;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_24__.createElement(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_26__/* .Text */ .x, {
        tag: "p",
        typography: "$bodyXsmall",
        whiteSpace: "normal",
        $largerThanSM: {
            whiteSpace: "nowrap"
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_24__.createElement(MARKETING_SMS_CONSENT.CtaAgreementLinked, {
        ctaText: "Continue",
        tosAnalyticsName: "".concat(analyticsName, "-terms"),
        privacyAnalyticsName: "".concat(analyticsName, "-privacy-policy"),
        linkProps: {
            variant: "primary",
            size: "xsmall"
        }
    }));
};
cov_1nsiyxuuhi().s[8]++;
var AccountFormHeader = function AccountFormHeader(_ref3) {
    var children = _ref3.children, rest = _objectWithoutProperties(_ref3, _excluded);
    cov_1nsiyxuuhi().f[4]++;
    cov_1nsiyxuuhi().s[9]++;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_24__.createElement(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_26__/* .Text */ .x, _extends({
        tag: "h1",
        typography: "$headerMedium"
    }, rest, {
        marginBottom: "$10x",
        textAlign: "left"
    }), children);
};
cov_1nsiyxuuhi().s[10]++;
var AccountFormWrapper = function AccountFormWrapper(props) {
    cov_1nsiyxuuhi().f[5]++;
    cov_1nsiyxuuhi().s[11]++;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_24__.createElement(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_27__/* .Box */ .x, _extends({
        width: "100%"
    }, props));
};
cov_1nsiyxuuhi().s[12]++;
var FormWrapper = function FormWrapper(props) {
    cov_1nsiyxuuhi().f[6]++;
    cov_1nsiyxuuhi().s[13]++;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_24__.createElement(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_27__/* .Box */ .x, _extends({
        width: "100%",
        flexDirection: "column"
    }, props));
};
cov_1nsiyxuuhi().s[14]++;
var PHONE_DEFAULT_DISCLAIMER = function PHONE_DEFAULT_DISCLAIMER(actionText) {
    cov_1nsiyxuuhi().f[7]++;
    cov_1nsiyxuuhi().s[15]++;
    return MARKETING_SMS_CONSENT.full(actionText);
};
// eslint-disable-next-line no-restricted-syntax
var Form = (cov_1nsiyxuuhi().s[16]++, /*#__PURE__*/ (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("form",  true ? {
    target: "e1a669rm0"
} : 0)( true ? {
    name: "g0ogvo",
    styles: "width:100%;margin-top:28px"
} : 0));
cov_1nsiyxuuhi().s[17]++;
var Disclaimer = function Disclaimer(_ref4) {
    var children = _ref4.children, _ref4$desktopNoWrap = _ref4.desktopNoWrap, desktopNoWrap = _ref4$desktopNoWrap === void 0 ? (cov_1nsiyxuuhi().b[3][0]++, false) : _ref4$desktopNoWrap, shouldRenderDisclaimerAboveCTA = _ref4.shouldRenderDisclaimerAboveCTA, props = _objectWithoutProperties(_ref4, _excluded2);
    cov_1nsiyxuuhi().f[8]++;
    cov_1nsiyxuuhi().s[18]++;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_24__.createElement(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_27__/* .Box */ .x, props, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_24__.createElement(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_26__/* .Text */ .x, {
        tag: "p",
        typography: "$bodyXsmall",
        color: "$contentSecondary",
        whiteSpace: "normal",
        $largerThanSM: desktopNoWrap ? (cov_1nsiyxuuhi().b[4][0]++, {
            whiteSpace: "nowrap"
        }) : (cov_1nsiyxuuhi().b[4][1]++, undefined)
    }, children));
}; //# sourceMappingURL=shared.mjs.map


/***/ }),

/***/ 73448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ CheckboxGroup; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36305);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20129);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46523);
/* harmony import */ var _shared_TrackableContainer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45822);
/* harmony import */ var _shared_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49555);
/* harmony import */ var _shared_CheckboxRadioGroupError__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4192);
/* harmony import */ var _shared_CheckboxRadioGroupLabel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33935);
/* harmony import */ var _SingleCheckbox__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(66099);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);















var checkboxTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__/* .tokens.radioCheckbox */ .T.radioCheckbox, CheckboxGroup = function(_param) {
    var analyticsName = _param.analyticsName, trackImpression = _param.trackImpression, options = _param.options, title = _param.title, supportText = _param.supportText, errorText = _param.errorText, invalid = _param.invalid, disabled = _param.disabled, initialCheckedValues = _param.initialCheckedValues, onPress = _param.onPress, id = _param.id, noneOfTheAboveValue = _param.noneOfTheAboveValue, required = _param.required, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "analyticsName",
        "trackImpression",
        "options",
        "title",
        "supportText",
        "errorText",
        "invalid",
        "disabled",
        "initialCheckedValues",
        "onPress",
        "id",
        "noneOfTheAboveValue",
        "required"
    ]);
    var ref = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.useProps)(props), _size = ref.size, size = _size === void 0 ? "medium" : _size, groupLabelId = (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useInputId */ .U0)(id), state = (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useInputState */ .U1)({
        errorText: errorText,
        invalid: invalid,
        disabled: disabled
    }).state, ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialCheckedValues !== null && initialCheckedValues !== void 0 ? initialCheckedValues : []), checkedValues = ref1[0], setCheckedValues = ref1[1], handleCheckedChange = function(value, _checked) {
        var newCheckedValues;
        value === noneOfTheAboveValue ? newCheckedValues = checkedValues.includes(noneOfTheAboveValue) ? [] : [
            noneOfTheAboveValue
        ] : newCheckedValues = checkedValues.includes(value) ? checkedValues.filter(function(val) {
            return val !== value;
        }) : (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(checkedValues.filter(function(val) {
            return val !== noneOfTheAboveValue;
        })).concat([
            value
        ]), setCheckedValues(newCheckedValues), onPress && onPress(newCheckedValues);
    };
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_shared_TrackableContainer__WEBPACK_IMPORTED_MODULE_7__/* .TrackableContainer */ .z, {
        analyticsName: analyticsName,
        trackImpression: trackImpression,
        gap: checkboxTokens.padding.titleRowGap[size],
        flexGrow: 1,
        eventName: "checkboxViewEvent",
        children: [
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_shared_CheckboxRadioGroupLabel__WEBPACK_IMPORTED_MODULE_8__/* .CheckboxRadioGroupLabel */ .L, {
                size: size,
                title: title,
                supportText: supportText,
                id: "".concat(groupLabelId, "-label"),
                state: state,
                required: required
            }),
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Box__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                role: "group",
                "aria-labelledby": "".concat(groupLabelId, "-label"),
                gap: checkboxTokens.padding.rowGap[size],
                children: options.map(function(option) {
                    var defaultChecked = initialCheckedValues === null || initialCheckedValues === void 0 ? void 0 : initialCheckedValues.includes(option.value), isNoneOfTheAbove = option.value === noneOfTheAboveValue;
                    return /* @__PURE__ */ /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_SingleCheckbox__WEBPACK_IMPORTED_MODULE_10__/* .SingleCheckbox */ .g, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, props), {
                        key: option.value,
                        analyticsName: analyticsName,
                        invalid: !!errorText || invalid,
                        disabled: disabled,
                        label: option.label,
                        subtitle: option.subtitle,
                        size: size,
                        value: option.value,
                        onPress: handleCheckedChange,
                        state: state,
                        defaultChecked: defaultChecked,
                        checked: checkedValues.includes(option.value),
                        id: "".concat(groupLabelId, "-").concat(option.value),
                        name: id,
                        hiddenCheckIcon: isNoneOfTheAbove,
                        renderLabel: option.renderLabel
                    }));
                })
            }),
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_shared_CheckboxRadioGroupError__WEBPACK_IMPORTED_MODULE_13__/* .CheckboxRadioGroupError */ .r, {
                errorText: errorText
            })
        ]
    });
};



/***/ }),

/***/ 66099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ SingleCheckbox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20129);
/* harmony import */ var _tamagui_checkbox_headless__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70357);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _generated_icons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(74816);
/* harmony import */ var _helpers_useObservabilitySafe__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1252);
/* harmony import */ var _helpers_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(56350);
/* harmony import */ var _shared_TrackableContainer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(45822);
/* harmony import */ var _shared_hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49555);
/* harmony import */ var _shared_CheckboxRadioLabel__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69973);
/* harmony import */ var _shared_hooks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68362);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);















var checkboxTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__/* .tokens.radioCheckbox */ .T.radioCheckbox, SingleCheckbox = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(_param, ref) {
    var analyticsName = _param.analyticsName, label = _param.label, value = _param.value, subtitle = _param.subtitle, _defaultChecked = _param.defaultChecked, defaultChecked = _defaultChecked === void 0 ? !1 : _defaultChecked, disabled = _param.disabled, invalid = _param.invalid, id = _param.id, onPress = _param.onPress, name = _param.name, trackImpression = _param.trackImpression, checked = _param.checked, _hiddenCheckIcon = _param.hiddenCheckIcon, hiddenCheckIcon = _hiddenCheckIcon === void 0 ? !1 : _hiddenCheckIcon, required = _param.required, renderLabel = _param.renderLabel, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "analyticsName",
        "label",
        "value",
        "subtitle",
        "defaultChecked",
        "disabled",
        "invalid",
        "id",
        "onPress",
        "name",
        "trackImpression",
        "checked",
        "hiddenCheckIcon",
        "required",
        "renderLabel"
    ]);
    var _$ref = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.useProps)(props), _size = _$ref.size, size = _size === void 0 ? "medium" : _size, trackJourneyEvent = (0,_helpers_useObservabilitySafe__WEBPACK_IMPORTED_MODULE_5__/* .useObservabilitySafe */ .r)().trackJourneyEvent, _$ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultChecked), internalChecked = _$ref1[0], setInternalChecked = _$ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        checked !== void 0 && setInternalChecked(checked);
    }, [
        checked
    ]);
    var onCheckedChange = function(e) {
        e.stopPropagation(), onPress && onPress(value, !internalChecked), trackJourneyEvent("platform", "checkboxClickEvent", {
            targetName: analyticsName,
            optionName: value
        });
    }, _$ref2 = (0,_tamagui_checkbox_headless__WEBPACK_IMPORTED_MODULE_6__/* .useCheckbox */ .O)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        name: name,
        value: value,
        defaultChecked: defaultChecked,
        disabled: disabled,
        onPress: onCheckedChange
    }, props), [
        internalChecked,
        setInternalChecked
    ], ref), checkboxProps = _$ref2.checkboxProps, checkboxRef = _$ref2.checkboxRef, bubbleInput = _$ref2.bubbleInput, inputId = (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useInputId */ .U0)(id), _$ref3 = (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_9__/* .useCheckBoxRadioState */ .D)({
        checked: internalChecked,
        disabled: disabled,
        invalid: invalid,
        onBlur: props.onBlur,
        onFocus: props.onFocus
    }), rowState = _$ref3.rowState, buttonState = _$ref3.buttonState, handleFocus = _$ref3.handleFocus, handleBlur = _$ref3.handleBlur, _$ref4 = getCheckMarkIconStyle(size, buttonState), checkMarkSize = _$ref4.checkMarkSize, checkMarkColor = _$ref4.checkMarkColor, defaultLabel = /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_shared_CheckboxRadioLabel__WEBPACK_IMPORTED_MODULE_10__/* .CheckboxRadioLabel */ .a, {
        id: inputId,
        label: label,
        size: size,
        subtitle: subtitle,
        state: rowState
    }), labelContent = renderLabel ? renderLabel(defaultLabel) : defaultLabel;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_shared_TrackableContainer__WEBPACK_IMPORTED_MODULE_11__/* .TrackableContainer */ .z, {
        analyticsName: analyticsName,
        trackImpression: trackImpression,
        eventName: "checkboxViewEvent",
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(CheckboxRowButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, checkboxProps), {
            "aria-invalid": _tamagui_core__WEBPACK_IMPORTED_MODULE_4__.isWeb ? invalid : void 0,
            "aria-required": _tamagui_core__WEBPACK_IMPORTED_MODULE_4__.isWeb ? required : void 0,
            ref: checkboxRef,
            size: size,
            state: rowState,
            onFocus: handleFocus,
            onBlur: handleBlur,
            focusable: !disabled,
            id: inputId,
            children: [
                labelContent,
                hiddenCheckIcon ? null : /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(CheckMarkFrame, {
                    disabled: disabled,
                    size: size,
                    state: {
                        state: buttonState,
                        checked: internalChecked
                    },
                    onFocus: handleFocus,
                    onBlur: handleBlur,
                    focusable: !1,
                    children: [
                        internalChecked === !0 && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_generated_icons__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            size: checkMarkSize,
                            color: checkMarkColor
                        }),
                        bubbleInput
                    ]
                })
            ]
        }))
    });
}), CheckboxRowButton = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.View, {
    tag: "button",
    display: "flex",
    flexDirection: "row",
    gap: checkboxTokens.padding.textCheckboxGap.default,
    variants: {
        /**
     * Size is here to get types to work
     */ size: function(_size) {
            return {};
        },
        /**
     * State and size are used in the same function because there are multiple
     * times we need to use both to determine the style (especially for
     * small/xsmall)
     */ state: function(state, param) {
            var props = param.props;
            var size = props.size;
            return (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_9__/* .getCustomRadioCheckboxRowStyling */ .q)({
                size: size,
                state: state
            });
        }
    }
}), CheckMarkFrame = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.Stack, {
    borderWidth: checkboxTokens.borderWidth.default,
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "auto",
    alignSelf: "center",
    variants: {
        size: function(size) {
            var buttonSize = size === "xsmall" || size === "small" ? "smallXsmall" : size, widthAndHeight = {
                smallXsmall: 24,
                medium: 26,
                large: 32
            };
            return {
                borderRadius: checkboxTokens.cornerRadius.element.checkbox[buttonSize],
                width: widthAndHeight[buttonSize],
                height: widthAndHeight[buttonSize]
            };
        },
        // eslint-disable-next-line jsdoc/require-jsdoc
        state: function(param) {
            var state = param.state, checked = param.checked;
            var borderColor = (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_14__/* .isKeyOfObject */ .E)(state, checkboxTokens.color.border.element.checkbox.state) ? checkboxTokens.color.border.element.checkbox.state[state] : checkboxTokens.color.border.element.checkbox.default, backgroundColor = (checked || state === "inactive") && (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_14__/* .isKeyOfObject */ .E)(state, checkboxTokens.color.background.element.checkboxRadio.state) ? checkboxTokens.color.background.element.checkboxRadio.state[state] : "$transparent";
            return {
                borderColor: borderColor,
                backgroundColor: backgroundColor
            };
        }
    }
}), getCheckMarkIconStyle = function(size, state) {
    return {
        checkMarkSize: size === "small" || size === "xsmall" ? 20 : 24,
        checkMarkColor: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_14__/* .isKeyOfObject */ .E)(state, checkboxTokens.color.content.element.checkIcon.state) ? checkboxTokens.color.content.element.checkIcon.state[state] : checkboxTokens.color.content.element.checkIcon.default
    };
};



/***/ }),

/***/ 4192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ CheckboxRadioGroupError; }
/* harmony export */ });
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20129);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46523);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76614);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var radioCheckbox = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__/* .tokens.radioCheckbox */ .T.radioCheckbox, CheckboxRadioGroupError = function(param) {
    var errorText = param.errorText;
    return errorText && typeof errorText == "string" ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Box__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, {
        testID: "checkbox-radio-group-error-message",
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
            tag: "span",
            typography: radioCheckbox.typography.errorMessage.default,
            color: radioCheckbox.color.content.errorMessage.default,
            children: errorText
        })
    }) : null;
};



/***/ }),

/***/ 33935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ CheckboxRadioGroupLabel; }
/* harmony export */ });
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20129);
/* harmony import */ var _helpers_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56350);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46523);
/* harmony import */ var _shared_InputLabelContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25689);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76614);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






var radioCheckbox = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__/* .tokens.radioCheckbox */ .T.radioCheckbox, CheckboxRadioGroupLabel = function(param) {
    var size = param.size, title = param.title, supportText = param.supportText, id = param.id, state = param.state, required = param.required;
    return (0,_shared_InputLabelContext__WEBPACK_IMPORTED_MODULE_2__/* .useCheckInputLabel */ .B)(title), title ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Box__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, {
        children: [
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Text__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                tag: "label",
                id: id,
                typography: radioCheckbox.typography.title[size],
                color: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_5__/* .isKeyOfObject */ .E)(state, radioCheckbox.color.content.title.state) ? radioCheckbox.color.content.title.state[state] : radioCheckbox.color.content.title.default,
                children: [
                    title,
                    required ? " *" : ""
                ]
            }),
            !!supportText && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                tag: "span",
                typography: radioCheckbox.typography.supportText.default,
                color: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_5__/* .isKeyOfObject */ .E)(state, radioCheckbox.color.content.supportText.state) ? radioCheckbox.color.content.supportText.state[state] : radioCheckbox.color.content.supportText.default,
                children: supportText
            })
        ]
    }) : null;
};



/***/ }),

/***/ 69973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ CheckboxRadioLabel; },
/* harmony export */   "w": function() { return /* binding */ RightAlignedRadioLabel; }
/* harmony export */ });
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20129);
/* harmony import */ var _helpers_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56350);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46523);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76614);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var radioCheckbox = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__/* .tokens.radioCheckbox */ .T.radioCheckbox, CheckboxRadioLabel = function(param) {
    var size = param.size, label = param.label, subtitle = param.subtitle, id = param.id, state = param.state;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Box__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, {
        alignSelf: "center",
        flex: 3,
        children: [
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                alignSelf: "flex-start",
                tag: "label",
                numberOfLines: 1,
                htmlFor: id,
                typography: radioCheckbox.typography.valueText[size],
                fontWeight: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_4__/* .isKeyOfObject */ .E)(size, radioCheckbox.fontWeight.override) ? radioCheckbox.fontWeight.override[size] : void 0,
                color: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_4__/* .isKeyOfObject */ .E)(state, radioCheckbox.color.content.valueText.state) ? radioCheckbox.color.content.valueText.state[state] : radioCheckbox.color.content.valueText.default,
                children: label
            }),
            !!subtitle && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                alignSelf: "flex-start",
                tag: "span",
                numberOfLines: 1,
                typography: radioCheckbox.typography.valueTextSecondLine[size],
                color: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_4__/* .isKeyOfObject */ .E)(state, radioCheckbox.color.content.valueTextRowTwo.state) ? radioCheckbox.color.content.valueTextRowTwo.state[state] : radioCheckbox.color.content.valueTextRowTwo.default,
                children: subtitle
            })
        ]
    });
}, RightAlignedRadioLabel = function(param) {
    var size = param.size, rightAlignedText = param.rightAlignedText, state = param.state;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Box__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, {
        alignSelf: "center",
        flex: 1,
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
            alignSelf: "flex-end",
            tag: "label",
            numberOfLines: 1,
            typography: radioCheckbox.typography.rightAligned[size],
            color: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_4__/* .isKeyOfObject */ .E)(state, radioCheckbox.color.content.valueText.state) ? radioCheckbox.color.content.valueText.state[state] : radioCheckbox.color.content.valueText.default,
            paddingRight: size === "xsmall" ? "$6x" : 0,
            children: rightAlignedText
        })
    });
};



/***/ })

}]);